export default `<svg 
  xmlns="http://www.w3.org/2000/svg" 
  width="18" 
  height="18" 
  viewBox="0 0 1024 1024"
>
  <path 
    d="M861.742 548.161l-349.742-303.724-349.727 303.724c-9.197 7.897-18.407 15.778-18.407 35.498v353.679c0 15.778 13.151 28.927 28.927 28.927h219.57v-277.427c0-15.778 11.837-27.602 27.602-27.602h184.073c15.778 0 27.602 11.837 27.602 27.602v278.735h219.57c15.778 0 28.927-13.151 28.927-28.927l-0.011-353.679c0-21.042-10.499-28.913-18.393-36.802zM1014.246 486.361l-178.803-156.467v-163.022c0-15.778-13.151-28.927-28.927-28.927h-47.337c-15.778 0-28.927 13.151-28.927 28.927v72.315l-198.514-174.876c-11.837-10.51-26.304-10.51-38.123 0l-483.848 422.052c-11.837 10.51-13.151 28.927-2.642 40.756l31.558 35.498c10.51 11.837 28.927 13.151 40.756 2.642l432.558-378.654 432.558 378.654c11.837 10.51 30.239 9.197 40.756-2.642l31.558-35.498c10.51-11.849 9.211-30.239-2.639-40.756z"
  ></path>
</svg>`;
